import update from 'immutability-helper';
import {AuthenticateActions} from '../actions/authenticate.actions';

const DEFAULT_STATE = {
    isSigningIn: false,
    isLoggingIn: false
};

export const authenticateReducer = (state = DEFAULT_STATE, action)=> {
    switch(action.type){
        case AuthenticateActions.SIGNIN:
            return update(state, {
                isSigningIn: {$set: true}
            });
        case AuthenticateActions.SIGNIN_SUCCESS:
        case AuthenticateActions.SIGNIN_FAILURE:
            return update(state, {
                isSigningIn: {$set: false}
            });
        case AuthenticateActions.LOGIN:
            return update(state, {
                isLoggingIn: {$set: true}
            });
        case AuthenticateActions.LOGIN_SUCCESS:
        case AuthenticateActions.LOGIN_FAILURE:
            return update(state, {
                isLoggingIn: {$set: false}
            });
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/authenticate.reducer.js